module.exports = __webpack_public_path__ + "img/frame (207).b15aab61.jpg";